/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconInnerShadowTopRight = createReactComponent(
  "inner-shadow-top-right",
  "IconInnerShadowTopRight",
  [
    ["path", { d: "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18z", key: "svg-0" }],
    ["path", { d: "M18 12a6 6 0 0 0 -6 -6", key: "svg-1" }]
  ]
);

export { IconInnerShadowTopRight as default };
//# sourceMappingURL=IconInnerShadowTopRight.js.map
